<template>
  <div style="height: 100%; overflow: auto">
    <b-card
      class="sa-card"
      header="Test Anagrafica Regionale"
      header-tag="header"
      footer-tag="footer"
      title=""
    >
      <b-form @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
            <label class="sa-label-data">Metodi</label>
            <b-form-select
              id="inline-form-custom-select-pref"
              v-model="metodoForm"
              class="mb-2 mr-sm-2 mb-sm-0"
              :value="null"
              value-field="nome"
              text-field="nome"
              :options="optionsMetodi"
              @input="loadLabelInput"
            ></b-form-select>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            v-for="item in optionsParameters"
            :key="item.path"
            cols="12"
            xs="12"
            sm="12"
            md="6"
            lg="4"
            xl="4"
          >
            <label class="sa-label-data">{{ item.nome }}</label>
            <b-form-select
              v-if="item.nome === 'codiceStruttura'"
              id="inline-form-custom-select-pref"
              v-model="valueInputObj[item.nome]"
              class="mb-2 mr-sm-2 mb-sm-0"
              value-field="codiceStruttura"
              text-field="descrizione"
              :options="optionsStructures"
            ></b-form-select>
            <b-form-input
              v-if="item.tipo === 'String' && item.nome !== 'codiceStruttura'"
              v-model="valueInputObj[item.nome]"
              class="text-uppercase"
            ></b-form-input>
            <b-form-select
              v-else-if="item.tipo === 'boolean'"
              id="inline-form-custom-select-pref"
              v-model="valueInputObj[item.nome]"
              class="mb-2 mr-sm-2 mb-sm-0"
              value-field="value"
              text-field="text"
              :options="optionsBooleanSelect"
            ></b-form-select>
          </b-col>
        </b-row>
        <!-- <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
            <label class="sa-label-data">Identificativo</label>
            <b-form-input v-model="identificativo"></b-form-input>
          </b-col> -->
        <b-row>
          <b-col class="sa-padding-right text-right" style="padding-top: 10px">
            <b-button type="reset" v-on:click="onReset" variant="outline-danger"
              >Reset</b-button
            >
            <b-button
              type="submit"
              variant="outline-info"
              :disabled="path === null"
              >Esegui Test</b-button
            >
          </b-col>
        </b-row>
      </b-form>
    </b-card>
    <b-card
      class="sa-card"
      header="Risposta"
      header-tag="header"
      footer-tag="footer"
      title=""
    >
      <div
        style="
          flex: 1;
          background-color: rgb(247, 247, 247);
          border: 1px solid #b5b3b3;
          padding: 5px;
          border-radius: 5px;
        "
      >
        <pre>{{ jsonData }}</pre>
      </div>
    </b-card>
  </div>
</template>
<script>
// import axios from "axios";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../utility/UtilityMixin";
// import FlussiDettagliModalViewComponent from "./FlussiDettagliModalViewComponent.vue";

export default {
  mixins: [UtilityMixin],
  components: {},
  data() {
    return {
      pathResource: "/anagraficaregionale/assistibileunificato/",
      struttura: null,
      path: null,
      identificativo: null,
      optionsMetodi: [],
      optionsStructures: [],
      metodoForm: null,
      optionsParameters: {},
      valueInputObj: {},
      optionsBooleanSelect: [
        { value: true, text: "Si" },
        { value: false, text: "No" },
      ],
      text: "assistibileunificato",
      jsonData: {},
      codiciStruttureOptions: [
        { value: null, text: "-Seleziona Valore-" },
        { value: "180000", text: "180000" },
        { value: "012000", text: "012000" },
        { value: "150206", text: "150206" },
      ],
    };
  },
  computed: {
    formattedJsonData() {
      if (!this.jsonData || Object.keys(this.jsonData).length === 0) {
        return "";
      }
      try {
        return JSON.stringify(this.jsonData, null, 2);
      } catch (error) {
        return "Errore nella formattazione del JSON";
      }
    },
  },
  mounted() {
    let me = this;
    me.loadDataOptionsMetodi();
    me.loadDatastructures();
  },
  methods: {
    onSubmit() {
      let me = this;
      console.log("path", me.path);
      console.log("options Parameters", me.optionsParameters);
      console.log("Valori input: ", me.valueInputObj);
      me.loadDataSubmit();
    },
    loadDataOptionsMetodi() {
      let me = this;
      UtilityMixin.methods.loadDataResources(
        "/anagraficaregionale/metadata/metodi",
        {},
        me.loadOptionsVersioneSuccess,
        me.loadOptionsVersioneError,
      );
    },
    loadLabelInput() {
      let me = this;
      me.valueInputObj = {};
      for (let i = 0; i < me.optionsMetodi.length; i++) {
        if (me.optionsMetodi[i].nome === me.metodoForm) {
          me.path = me.optionsMetodi[i].path;
          me.optionsParameters = me.optionsMetodi[i].parametri;
          return me.optionsParameters;
        }
      }
    },
    loadOptionsVersioneSuccess(response) {
      let me = this;
      me.optionsMetodi = response.data.data;
    },
    loadOptionsVersioneError(error) {
      console.log(error);
    },
    loadDataSubmit() {
      let me = this;
      // uso regex per estrarre il pathParams
      const regexValoreGraffe = /(?<=\{)[^}]+(?=\})/g;
      const valorePathParams = me.path.match(regexValoreGraffe);
      //troviamo il valore con origine = pathParams
      if (valorePathParams) {
        const pathSenzaParams = me.path.replace(/\{.*/, "");
        const findPathInOptionsParameters = me.optionsParameters.find(
          (el) => el.origine === "pathParam",
        );
        const pathParams = findPathInOptionsParameters.nome;
        // destrutturo con la key nome presente nel oggetto trovato nel find
        if (findPathInOptionsParameters) {
          const { [pathParams]: findPathInOptionsParameters, ...queryParams } =
            me.valueInputObj;
          // qui creo il path dinamico concatenando
          const pathConParamsDinamico =
            "/" + pathSenzaParams + findPathInOptionsParameters;
          console.log("PathDinamico: ", pathConParamsDinamico);
          UtilityMixin.methods.loadDataResources(
            pathConParamsDinamico,
            queryParams,
            me.loadDataSuccess,
            me.loadDataError,
          );
        }
      }

      //   // qui controlliamo che nel path ci sia effettivamente un pathParams da sostituire
      //   if (valorePathParams) {
      //     console.log("valore PathParams: ", valorePathParams[0]);

      //     const pathSenzaParams = me.path.replace(/\{.*/, "");
      //     console.log("pathSenzaParams: ", pathSenzaParams);
      //     const { codiceStruttura, ...queryParams } = me.valueInputObj;
      //     if (codiceStruttura) {
      //       const pathConParamsDinamico = "/" + pathSenzaParams + codiceStruttura;
      //       console.log("pathCompleto", pathConParamsDinamico);
      //       UtilityMixin.methods.loadDataResources(
      //         pathConParamsDinamico,
      //         queryParams,
      //         me.loadDataSuccess,
      //         me.loadDataError,
      //       );
      //       console.log("Chiamata Submit: ");
      //     }
      //   }
    },
    loadDataSuccess(response) {
      console.log("CHIAMATA EFFETTUATA CON SUCCESSO");
      let me = this;
      me.jsonData = response.data;
      me.$emit("afterLoadData");
      me.listKey++;
    },
    loadDataError(response) {
      console.log("CHIAMATA Fallita");
      let me = this;
      me.jsonData = response.response.data;
    },
    loadDatastructures() {
      let me = this;
      UtilityMixin.methods.loadDataResources(
        "/anagraficaregionale/metadata/strutture",
        {},
        me.loadDatastructuresSuccess,
        me.loadDataError,
      );
    },
    loadDatastructuresSuccess(response) {
      let me = this;
      me.optionsStructures = response.data.data.list;
      console.log("Strutture: ", response.data.data.list);
    },
    loadDatastructuresError(response) {
      let me = this;
      me.optionsStructures = response.response.data;
    },
    onReset() {
      let me = this;
      me.identificativo = null;
      me.struttura = null;
      me.jsonData = {};
    },
  },
};
</script>
